import React from 'react';

import { ExportTestCasesProvider } from '@qality/common-components/src/lib/ExportTestCasesProvider';
import { ExportTestCasesModal } from '@qality/common-components/src/organisms/ExportTestCases';

type Props = {
  onCloseDialog: () => void;
};

export default function DialogExportTestCasesPage({
  onCloseDialog,
}: Props): JSX.Element {
  return (
    <ExportTestCasesProvider>
      <ExportTestCasesModal onCloseDialog={onCloseDialog} autoExportFromUrl />
    </ExportTestCasesProvider>
  );
}
